import React from 'react';
import {AgreementDialog} from './AgreementDialog';
import {MapStateToProps, connect} from 'react-redux';
import {getAffiliateAgreement} from '../../selectors/eula.selectors';

interface OwnProps {
    open: boolean;
    onClose: () => void;
}
interface StateProps {
    body: string;
    title: string;
}
type Props = OwnProps & StateProps;

const AffiliateDialog: React.FunctionComponent<Props> = props => <AgreementDialog {...props} />;

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
    body: getAffiliateAgreement(state).body,
    title: getAffiliateAgreement(state).title
});

export default connect(mapStateToProps)(AffiliateDialog);
